<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 19
    </div>
    <div class="chapter-title">Журнал погружения свай</div>
    <n-items v-if="project">
      <n-input title="Ответственный за ведение журнала" v-bind="$form.input('records')" :text="!editable" />
      <n-input title="Сваи №" v-bind="$form.input('pileNumber')" :text="!editable" />
      <n-input title="1.1.1.1. Система копра (тип направляющего оборудования)" v-bind="$form.input('corpSystem')" :text="!editable" />
      <n-input title="1.1 1.2. Тип молота" v-bind="$form.input('hammerType')" :text="!editable" />
      <n-input title="1.1.1.3. Вес ударной части молота, кН" v-bind="$form.input('hammerWeight')" :text="!editable" />
      <n-input title="1.1.1.4. Давление (воздуха, пара) по паспорту, МПа" v-bind="$form.input('airPressure')" :text="!editable" />
      <n-input title="1.1.1.5. Энергия удара молота (по паспорту), кДж (кН·м)" v-bind="$form.input('hammerPunchEnergy')" :text="!editable" />
      <n-input title="1.1.1.6. Тип и вес наголовника, кН" v-bind="$form.input('typeWeight')" :text="!editable" />
      <n-input title="1.1.1.7. Характеристика амортизаторов свайного наголовника" v-bind="$form.input('hammerChar')" :text="!editable" />
      <n-input title="2.2.2 Отметка уровня воды, м" v-bind="$form.input('markWaterLevel')" :text="!editable" />
      <n-input title="2.2.3 Проектный отказ, см" v-bind="$form.input('projectDecline')" :text="!editable" />
      <n-input title="при высоте падения ударной часта молота, м" v-bind="$form.input('heightFall')" :text="!editable" />
      <n-input title="Схематический план свайного поля с привязкой к осям опор и указанием номеров сваи." v-bind="$form.input('schemaPlan')" :text="!editable" />
      <n-input title="Начальник производственно-технического отдела" v-bind="$form.input('tech')" :text="!editable" />
      <n-input title="Свая № (по плану)" v-bind="$form.input('pileNumberPlan')" :text="!editable" />
      <n-input title="2.2.4 Дата забивки (и добивки)" v-bind="$form.input('datePilePunching')" :text="!editable" />
      <n-input title="Смена от, час" v-bind="$form.input('shiftFromH')" :text="!editable" />
      <n-input title="Смена до, час" v-bind="$form.input('shiftUntilH')" :text="!editable" />
      <n-input title="2.2.5 Марка сваи " v-bind="$form.input('pileMark')" :text="!editable" />
      <n-input title="Паспортный №" v-bind="$form.input('passportNumber')" :text="!editable" />
      <n-input title="Материал" v-bind="$form.input('material')" :text="!editable" />
      <n-input title="Длина, м" v-bind="$form.input('length')" :text="!editable" />
      <n-input title="Поперечное сечение, см" v-bind="$form.input('transverse')" :text="!editable" />
      <div style="width: 100%;">2.2.6 Отметки:</div>
      <n-input title="Поверхности грунта у сваи" v-bind="$form.input('markEarthTop')" :text="!editable" />
      <n-input title="острия сваи, проектная " v-bind="$form.input('markPileTopProject')" :text="!editable" />
      <n-input title="острия сваи, фактическая " v-bind="$form.input('markPileTopFact')" :text="!editable" />
      <n-input title="2.2.7 Глубина погружения, м" v-bind="$form.input('markDeep')" :text="!editable" />
      <n-input title="Бригада" v-bind="$form.input('brigade')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
